import router from '@/router'

export const toLogin = () => {
  router.replace({
    name: 'Login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  })
}

export const to403 = () => {
  router.replace({
    name: '403'
  })
}
